export const getPercentage = (percent: number) => {
  return Math.round(percent);
};
